"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "flex" };
const _hoisted_3 = ["min", "max"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "number",
                class: "nes-input",
                value: "playerinput.min",
                min: _ctx.playerinput.min,
                max: _ctx.playerinput.max,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.amount) = $event))
            }, null, 8, _hoisted_3), [
                [vue_1.vModelText, _ctx.amount]
            ]),
            _cache[1] || (_cache[1] = (0, vue_1.createTextVNode)("   ", -1)),
            (0, vue_1.createVNode)(_component_AppButton, {
                size: "big",
                type: "max",
                onClick: _ctx.setMaxValue,
                title: "MAX"
            }, null, 8, ["onClick"]),
            _cache[2] || (_cache[2] = (0, vue_1.createTextVNode)("   ", -1)),
            (_ctx.showsave === true)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                    key: 0,
                    size: "big",
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel
                }, null, 8, ["onClick", "title"]))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ]));
}
